module.exports = __webpack_public_path__ + "static/img/102421.3b82cd66.png";